"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6533],{

/***/ 65651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ logoAlt; },
/* harmony export */   "j1": function() { return /* binding */ logoPath; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_atomic_react_LogoLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46096);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30233);




const logoPath = "/images/graphpad/logo/logo-graphpad-dotmatics.svg";
const logoAlt = "GraphPad by Dotmatics";
const prerenderedLogo = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_LogoLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    href: _routes__WEBPACK_IMPORTED_MODULE_3__/* ["default"].external.index */ .Z.external.index,
    imgSrc: logoPath,
    alt: logoAlt,
    "data-qa-selector": "header-logo"
});
/* harmony default export */ __webpack_exports__["ZP"] = (prerenderedLogo);


/***/ }),

/***/ 6533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ src_SiteLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Layout/index.js + 1 modules
var Layout = __webpack_require__(71412);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/index.js + 1 modules
var Footer = __webpack_require__(9458);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Container.js
var Container = __webpack_require__(38661);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Main.js
var Main = __webpack_require__(78682);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/Nav.js
var Nav = __webpack_require__(53512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/CopyrightV3.js
var CopyrightV3 = __webpack_require__(20111);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Footer/LogoV3.js
var LogoV3 = __webpack_require__(74417);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/i18/index.js + 14 modules
var i18 = __webpack_require__(24155);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/NextLink/index.js
var NextLink = __webpack_require__(5098);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
// EXTERNAL MODULE: ./src/PrerenderedLogo/index.js
var PrerenderedLogo = __webpack_require__(65651);
;// CONCATENATED MODULE: ./src/SiteFooter/index.js












const SiteFooter = ()=>{
    const [t] = (0,i18/* useLocale */.bU)("footer");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Footer/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Main/* default */.Z, {
                    lg: 12,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.ZP, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavRow */.z4, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("SCIENTIFIC_SOFTWARE")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.graphPadPrism */.Z.external.graphPadPrism,
                                                        children: t("GRAPHPAD_PRISM")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.freeTrial */.Z.external.freeTrial,
                                                        children: t("PRISM_FREE_TRIAL")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.customers */.Z.external.customers,
                                                        children: t("PRISM_CUSTOMERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.instat */.Z.external.instat,
                                                        children: t("INSTAT")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.statMate */.Z.external.statMate,
                                                        children: t("STATMATE")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("HOW_TO_BUY")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.howToBuy */.Z.external.howToBuy,
                                                        children: t("PRICING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.student */.Z.external.student,
                                                        children: t("STUDENT_PRICING")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.professorCourseLicenses */.Z.external.professorCourseLicenses,
                                                        children: t("PROFESSOR_COURSE_LICENSES")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.graphPadChina */.Z.external.graphPadChina,
                                                        children: t("GRAPHPAD_CHINA")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("DATA_ANALYSIS_RESOURCES")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.quickCalcs */.Z.external.quickCalcs,
                                                        children: t("QUICKCALCS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.resources */.Z.external.resources,
                                                        children: t("PRODUCT_TUTORIALS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.statisticsGuide */.Z.external.statisticsGuide,
                                                        children: t("STATISTICS_GUIDE")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.curveFittingGuide */.Z.external.curveFittingGuide,
                                                        children: t("CURVE_FITTING_GUIDE")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                                        Component: Nav/* FooterNavItemLink */.jO,
                                                        href: routes/* default.prismAcademy */.Z.prismAcademy,
                                                        children: t("PRISM_ACADEMY")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("HELP")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.support */.Z.external.support,
                                                        children: t("SUPPORT")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.prismUserGuide */.Z.external.prismUserGuide,
                                                        children: t("PRISM_USER_GUIDE")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavCol */.Pw, {
                                    sm: 6,
                                    md: "auto",
                                    lg: "auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListTitle */.Q1, {
                                            children: t("COMPANY")
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Nav/* FooterNavList */.Hr, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.about */.Z.external.about,
                                                        children: t("ABOUT")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.careers */.Z.external.careers,
                                                        children: t("CAREERS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.portfolio */.Z.external.portfolio,
                                                        children: t("PORTFOLIO")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.dotmatics */.Z.external.dotmatics,
                                                        children: t("DOTMATICS")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavListItem */.iT, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* FooterNavItemLink */.jO, {
                                                        href: routes/* default.external.contacts */.Z.external.contacts,
                                                        children: t("CONTACT")
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyrightV3/* default */.ZP, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoV3/* default */.Z, {
                        href: routes/* default.external.index */.Z.external.index,
                        logoPath: PrerenderedLogo/* logoPath */.j1,
                        logoAlt: PrerenderedLogo/* logoAlt */.B$
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyrightV3/* FooterCopyrightV3Text */.JG, {
                        children: [
                            t("ALL_RIGHTS_RESERVED", {
                                yyyy: new Date().getFullYear()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightV3/* FooterCopyrightV3Link */.QC, {
                                href: routes/* default.external.termsOfService */.Z.external.termsOfService,
                                children: t("TERMS")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightV3/* FooterCopyrightV3Text.Separate */.JG.Separate, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyrightV3/* FooterCopyrightV3Link */.QC, {
                                href: routes/* default.external.privacyPolicy */.Z.external.privacyPolicy,
                                children: t("PRIVACY")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var src_SiteFooter = (SiteFooter);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Header/index.js + 6 modules
var Header = __webpack_require__(38529);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/index.js + 1 modules
var Navbar = __webpack_require__(37762);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Item.js
var Item = __webpack_require__(88881);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Link.js
var Link = __webpack_require__(81453);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarSearch/index.js + 1 modules
var NavbarSearch = __webpack_require__(2176);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Button/index.js + 1 modules
var Button = __webpack_require__(18774);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Form/index.js + 1 modules
var Form = __webpack_require__(22950);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Input/index.js + 2 modules
var Input = __webpack_require__(6470);
;// CONCATENATED MODULE: ./src/SiteHeader/index.js















const SiteHeader = (param)=>{
    let { isAuthorized =false  } = param;
    const [t] = (0,i18/* useLocale */.bU)("header");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header/* default */.Z, {
        logo: PrerenderedLogo/* default */.ZP,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default */.Z, {
                inverted: true,
                nav: "primary",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: routes/* default.external.graphPadPrism */.Z.external.graphPadPrism,
                            children: t("PRISM")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: routes/* default.external.customers */.Z.external.customers,
                            children: t("CUSTOMERS")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: routes/* default.external.resources */.Z.external.resources,
                            children: t("RESOURCES")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: routes/* default.external.support */.Z.external.support,
                            children: t("SUPPORT")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                            href: routes/* default.external.howToBuy */.Z.external.howToBuy,
                            children: t("HOW_TO_BUY")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Navbar/* default */.Z, {
                nav: "secondary",
                inverted: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                        secondary: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            href: routes/* default.external.cart */.Z.external.cart,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "shopping-cart"
                                }),
                                t("CART")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                        secondary: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* default */.Z, {
                            href: routes/* default.myAccount */.Z.myAccount,
                            className: "nav__item-link",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "user-alt"
                                }),
                                " ",
                                isAuthorized ? t("MY_ACCOUNT") : t("SIGNIN")
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarSearch/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
                            method: "get",
                            action: "/search/",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                type: "search",
                                id: "searchquery",
                                name: "searchquery",
                                placeholder: "Search...",
                                autoComplete: "off"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
                        secondary: true,
                        className: "secondary-nav__item-trial",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default.Link */.Z.Link, {
                            size: "s",
                            href: routes/* default.external.freeTrial */.Z.external.freeTrial,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
                                    name: "arrow-to-bottom"
                                }),
                                " ",
                                t("FREE_TRIAL")
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
SiteHeader.propTypes = {
    isAuthorized: prop_types.bool
};
/* harmony default export */ var src_SiteHeader = (SiteHeader);

// EXTERNAL MODULE: ./src/hooks/useIsAuthorized.js
var useIsAuthorized = __webpack_require__(82952);
;// CONCATENATED MODULE: ./src/SiteLayout/index.js







const SiteLayoutPure = (param)=>{
    let { bodyClassName ="" , children , isAuthorized , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        isWrapper: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Header */.Z.Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_SiteHeader, {
                    ...props,
                    isAuthorized: isAuthorized
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Body */.Z.Body, {
                className: bodyClassName,
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default.Footer */.Z.Footer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(src_SiteFooter, {})
            })
        ]
    });
};
SiteLayoutPure.propTypes = {
    bodyClassName: prop_types.string,
    isAuthorized: prop_types.bool,
    children: prop_types.node,
    hero: prop_types.bool
};
const SiteLayout = (props)=>{
    const isAuthorized = (0,useIsAuthorized/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiteLayoutPure, {
        ...props,
        isAuthorized: isAuthorized
    });
};
SiteLayout.Pure = SiteLayoutPure;
/* harmony default export */ var src_SiteLayout = (SiteLayout);


/***/ })

}]);